module.exports = __webpack_public_path__ + "static/media/administration.ad3a5400.svg";